import { AppMode } from "../AppMode";
import { Terminal } from "../Terminal";

export class Links 
{
    constructor(private appMode: AppMode, private terminal: Terminal)
    {
    }


    public linkPlayArea(): string
    {
        let url: string = "https://www.heathrow.com/at-the-airport/terminal-facilities/family-facilities#playareas";
        return url;
    }

    public linkBabyChanging(): string
    {
        return "https://maps.heathrow.com/?s=eyJvbmxpbmUvaGVhZGVyT25saW5lIjp7InNlYXJjaCI6ImJhYnkiLCJpc1NlYXJjaENvbmZpcm1lZCI6ZmFsc2V9LCJtYXBSZW5kZXJlciI6eyJ2cCI6eyJsYXQiOjUxLjQ2NjEsImxuZyI6LTAuNDY1ODA0LCJ6b29tIjoxNC40Njg5NzUsImJlYXJpbmciOjAsInBpdGNoIjowfSwib3JkIjoyfX0%3D";
    }

    public linkBabyChangingArrivals(): string
    {
        return "https://maps.heathrow.com/?s=eyJvbmxpbmUvaGVhZGVyT25saW5lIjp7InNlYXJjaCI6ImJhYnkiLCJpc1NlYXJjaENvbmZpcm1lZCI6ZmFsc2V9LCJtYXBSZW5kZXJlciI6eyJ2cCI6eyJsYXQiOjUxLjQ2NjEsImxuZyI6LTAuNDY1ODA0LCJ6b29tIjoxNC40Njg5NzUsImJlYXJpbmciOjAsInBpdGNoIjowfSwib3JkIjoyfX0%3D";
    }

    public linkKidsEatFree(): string
    {
        return "https://www.heathrow.com/at-the-airport/restaurants-a-z/kids-eat-free";
    }

    public linkEssentialShopping(): string
    {
        return "https://www.heathrow.com/at-the-airport/shopping";
    }

    public linkMailingList(): string
    {
        return "https://www.heathrow.com/communications";
    }

    public linkHeathrowExpress(): string
    {
        return "https://www.heathrow.com/transport-and-directions/by-rail-or-train/heathrow-express";
    }
}